import React from 'react'
import { Button, Space } from 'antd';
//import moment from 'moment'
//import locale from 'antd/es/date-picker/locale/fr_FR';
import 'moment/locale/fr';
//import { IconExcel } from '../../ressource/svg/excel.svg'
import PropTypes from 'prop-types';
import { SearchOutlined } from '@ant-design/icons';
import { DateFilter } from './FilterInput';





export class FilterDropDown extends React.Component {

    render() {
        return (
            <div style={{ padding: 8 }}>
                {this.props.children}
                <Space>
                    <Button
                        type="primary"
                        onClick={() => this.props.confirm()}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Chercher
                    </Button>
                    <Button onClick={() => this.props.clearFilters()} size="small" style={{ width: 90 }}>
                        Supprimer
                    </Button>

                </Space>
            </div>
        )
    }

}


export const FilterDateDropDown = ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8, width: 600, zIndex: 'auto' }}>
        <DateFilter
            selectedKeys={selectedKeys}
            showTime={false}
            onChange={value => {

                setSelectedKeys(value ? [value] : [])

            }}

        />

        <Space>
            <Button
                type="primary"
                onClick={() => {
                    confirm()

                }}
                icon={<SearchOutlined />}
                size="small"
                style={{ width: 90 }}
            >
                Chercher
            </Button>
            <Button onClick={() => {
                clearFilters()
            }}
                size="small" style={{ width: 90 }}>
                Supprimer
            </Button>

        </Space>
    </div>)



FilterDropDown.propTypes = {
    setSelectedKeys: PropTypes.func,
    selectedKeys: PropTypes.array,
    confirm: PropTypes.func,
    clearFilters: PropTypes.func,
    children: PropTypes.any
}